<!--模板界面-->
<template>
	<div>
		<p class="bigTitle">工单状态</p>
		<p style="color: white;margin-left: 26px;">工单总数：555555</p>
		<vchart style="height: calc(100% - 110px);" ref='vchart' themes="UbiquitousOverviewChartSkin"></vchart>
	</div>
</template>

<script>
	import vchart from '@/components/module/chart/vchart.vue'
	export default {
		components: {
			vchart
		},
		props: {},
		data() {
			return {
				options: {
					color: ['#00BFEF', '#ff9a16', '#ff6c4e'],
					tooltip: {
						trigger: 'item',
						formatter: "{a}</br>{b} : {c} ({d}%)"
					},
					legend: {
						orient: 'vertical',
						right:0,
						bottom:0,
						textStyle:{
							color:"whtie"
						}
					},
					series: [{
						name: '占比',
						type: 'pie',
						radius: ['40%', '80%'],
						data: []
					}]
				}
			}
		},
		created() {},
		mounted() {
			this.$refs.vchart.setData(this.options, true)
			this.initData()
		},
		destroyed() {},
		computed: {},
		watch: {},
		methods: {
			initData() {
				var list = []
				list.push({
					name: "未分派",
					value: 60
				})
				list.push({
					name: "处理中",
					value: 15
				})
				list.push({
					name: "已完成",
					value: 25
				})
				this.options.series[0].data = list
				this.$refs.vchart.setData(this.options, true)
			}
		}
	}
</script>

<style scoped>
	p.bigTitle {
		width: 100%;
		color: #00C6FF;
		font-size: 18px;
		font-weight: bold;
		text-align: center;
		margin-top: 10px;
		margin-bottom: 5px;
	}
</style>
